import { Row, Col, Space, Form, Input, Button, message } from "antd";
import { SearchOutlined, GoogleOutlined, FormOutlined } from "@ant-design/icons";
import axios from "axios";
import React from "react";

const App = () => {
    const [form] = Form.useForm();
    const handleOnFinish = (values) => {
        console.log(values)
        axios
            .get('/xxx/xxx')
            .then(() => {
                message.success('已完成推薦，請期待新進藏書')
            })
            .catch(() => {
                message.error('推薦失敗，請通知館員')
            })
    }
    return (<>
        <Row>
            <Col lg={{ span: 24 }} xs={{ span: 0 }}>
                <Row gutter={[0, 20]}>
                    <Col>
                        <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                            書籍推薦
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ backgroundColor: '#f2f2f2', padding: '20px', borderRadius: '5px' }}>
                            <Row align={'middle'} gutter={20}>
                                <Col style={{ fontSize: '1.3em' }}>
                                    說明
                                </Col>
                                <Col />
                                <Col>
                                    <Space direction="vertical">
                                        <text>01.書名、ISBN、作者為必填，其餘選填</text>
                                        <text>02.可於書名或ISBN填寫阙鍵字，跕選輸入框右側按鈕查詢書目</text>
                                        <text>口使用FindBook查詢 C 使用Google國書查詢</text>
                                        <text>03.若使用書目查詢鈕查找不到書目，請手功输入紅色星號三項必填欄位後新增推蘭。</text>
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ backgroundColor: 'white', borderRadius: '5px', display: 'flex', justifyContent: 'space-around', border: 'lightgrey solid 1px' }}>
                            <div style={{ width: '-webkit-fill-available', padding: '20px' }}>
                                <Form
                                    form={form}
                                    size="small"
                                    name="basic"
                                    labelCol={{
                                        span: 4,
                                    }}
                                    // wrapperCol={{
                                    //     span: 8,
                                    // }}
                                    style={{
                                        maxWidth: 600,
                                    }}
                                    initialValues={{
                                        remember: true,
                                    }}
                                    autoComplete="off"
                                >
                                    <text style={{ fontSize: '1.5em', color: 'red' }}>*必填</text>
                                    <Form.Item
                                        label="書名"
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Space>
                                            <Input defaultValue={'南方，寂寞鐵道：我們在時光列車上相遇'} />
                                            <a><Space><SearchOutlined />FindBook</Space></a>
                                            <a><Space><GoogleOutlined />Google圖書</Space></a>
                                        </Space>
                                    </Form.Item>


                                    <Form.Item
                                        label="ISBN"
                                        name="ISBN"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Space>
                                            <Input defaultValue={'98763452545'} />
                                            <a><Space><SearchOutlined />FindBook</Space></a>
                                            <a><Space><GoogleOutlined />Google圖書</Space></a>
                                        </Space>
                                    </Form.Item>

                                    <Form.Item
                                        label="作者"
                                        name="Author"
                                        // wrapperCol={{
                                        //     span: 8,
                                        // }}
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input defaultValue={'蕭菊貞'} style={{ width: '172px' }} />
                                    </Form.Item>
                                </Form>
                            </div>
                            <div style={{ border: 'black dashed 1px' }} />
                            <div style={{ width: '-webkit-fill-available', padding: '20px' }}>
                                <Form
                                    form={form}
                                    name="basic"
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 8,
                                    }}
                                    style={{
                                        maxWidth: 600,
                                    }}
                                    initialValues={{
                                        remember: true,
                                    }}
                                    autoComplete="off"
                                    onFinish={handleOnFinish}
                                >
                                    <div><text style={{ fontSize: '1.5em', color: 'darkred' }}>選填</text><text style={{ fontSize: '1em', color: 'red' }}>（填寫可以加迷購書速度哦！）</text></div>
                                    <Form.Item
                                        label="參考網址"
                                        name="Link"
                                    >
                                        <Input defaultValue={'www.BookStore.com'} />
                                    </Form.Item>

                                    <Form.Item
                                        label="出版社"
                                        name="Publisher"
                                    >
                                        <Input defaultValue={'大塊文化'} />
                                    </Form.Item>
                                    <Form.Item
                                        label="定價"
                                        name="Price"
                                    >
                                        <Input defaultValue={'473'} />
                                    </Form.Item>
                                    <Form.Item
                                        label="出版西元年"
                                        name="Year"
                                    >
                                        <Input defaultValue={'2023/06/02'} />
                                    </Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        提交<FormOutlined />
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col lg={{ span: 0 }} xs={{ span: 24 }}>
                <Row gutter={[0, 20]}>
                    <Col>
                        <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                            書籍推薦
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ backgroundColor: 'lightgrey', padding: '20px', borderRadius: '5px' }}>
                            <Row align={'middle'} gutter={[20, 20]}>
                                <Col style={{ fontSize: '1.3em' }}>
                                    說明
                                </Col>
                                <Col />
                                <Col>
                                    <Space direction="vertical">
                                        <text>01.書名、ISBN、作者為必填，其餘選填</text>
                                        <text>02.可於書名或ISBN填寫阙鍵字，跕選輸入框右側按鈕查詢書目</text>
                                        <text>口使用FindBook查詢 C 使用Google國書查詢</text>
                                        <text>03.若使用書目查詢鈕查找不到書目，請手功输入紅色星號三項必填欄位後新增推蘭。</text>
                                    </Space>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ backgroundColor: 'white', borderRadius: '5px', display: 'flex', justifyContent: 'space-around', border: 'lightgrey solid 1px' }}>
                            <div style={{ width: '-webkit-fill-available', padding: '20px' }}>
                                <Form
                                    form={form}
                                    // size="small"
                                    name="basic"
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 16,
                                    }}
                                    initialValues={{
                                        remember: true,
                                    }}
                                    autoComplete="off"
                                >
                                    <Space>
                                        <text style={{ fontSize: '1.5em', color: 'red' }}>*必填</text>
                                        <a><Space><SearchOutlined />FindBook</Space></a>
                                        <a><Space><GoogleOutlined />Google圖書</Space></a>
                                    </Space>
                                    <Form.Item
                                        label="書名"
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input defaultValue={'南方，寂寞鐵道：我們在時光列車上相遇'} />
                                    </Form.Item>

                                    <Form.Item
                                        label="ISBN"
                                        name="ISBN"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input defaultValue={'98763452545'} />
                                    </Form.Item>

                                    <Form.Item
                                        label="作者"
                                        name="Author"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input defaultValue={'蕭菊貞'} />
                                    </Form.Item>
                                    <div style={{ border: 'black dashed 1px' }} />
                                    <div><text style={{ fontSize: '1.5em', color: 'darkred' }}>選填</text><text style={{ fontSize: '1em', color: 'red' }}>（填寫可以加迷購書速度哦！）</text></div>
                                    <Form.Item
                                        label="參考網址"
                                        name="Link"
                                    >
                                        <Input defaultValue={'www.BookStore.com'} />
                                    </Form.Item>

                                    <Form.Item
                                        label="出版社"
                                        name="Publisher"
                                    >
                                        <Input defaultValue={'大塊文化'} />
                                    </Form.Item>
                                    <Form.Item
                                        label="定價"
                                        name="Price"
                                    >
                                        <Input defaultValue={'473'} />
                                    </Form.Item>
                                    <Form.Item
                                        label="出版西元年"
                                        name="Year"
                                    >
                                        <Input defaultValue={'2023/06/02'} />
                                    </Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>


    </>)
}

export default App